import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Address } from 'src/app/Models/address';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { AddressControlComponent } from 'src/app/shared/address-control/address-control.component';

@Component({
  selector: 'update-address-modal',
  templateUrl: './dialog-update-address.component.html',
  styleUrls: ['./dialog-update-address.component.scss']
})
export class UpdateAddressModalComponent implements OnInit {

    @ViewChild('addressControl') addressControl: AddressControlComponent;
    index: number = 0;

    constructor(@Inject(MAT_DIALOG_DATA) public data: Address[], public dialogRef: MatDialogRef<UpdateAddressModalComponent>, 
        private apiService: ApiService, private messageService: MessageService) { }

    ngOnInit(): void {
        if(!this.data) {
            this.data = new Array<Address>();
        } else {
            this.changeAddress(true);
        }
    }

    onClickCancel(): void {
        this.dialogRef.close();
    }

    onClickBack(): void {
        if(this.index > 0) {
            this.addressControl.onStopTimer();
            this.index--;
            this.changeAddress(false);
        }
    }

    OnClickNext(): void {
        this.saveAddress(this.data[this.index]); // Bloquear para simular
        
        // this.saveSuccess(); // Desbloquear para simular
    }

    saveAddress(address: Address) {
        this.addressControl.onStopTimer();
        this.apiService.put('api/address', address).subscribe(() => {
            this.saveSuccess();
            this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
            {
              article: 'GENERAL.MESSAGE.THE_1',
              function: 'ADDRESS.MESSAGE',
              action: 'GENERAL.MESSAGE.ACTIONS.ACTION_UPDATE'
            });
        });
    }

    private saveSuccess() {
        this.data[this.index].latitude = this.addressControl.lat;
        this.data[this.index].longitude = this.addressControl.long;
        // this.addressControl.onStopTimer(); // Desbloquear para simular
        this.changeIndex();
    }

    private changeIndex() {
        this.index++;
        if(this.index == this.data.length) {
            this.onClickCancel();
        } else {
            this.changeAddress(!(this.data[this.index].latitude && this.data[this.index].longitude));
        }
    }

    private changeAddress(getCoord: boolean) {
        this.addressControl.setAddressData(this.data[this.index], false);
        if(!getCoord) {
            this.addressControl.setLatLong(this.data[this.index].latitude, this.data[this.index].longitude);
            this.addressControl.dataSource = [];
        }
    }
}